import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import { CreateReferralV5Command } from "../types/CreateReferralCommandV5";

export interface CreatedReferralV5Response {
  referralCode: string;
}

export const referralApiV5 = createApi({
  reducerPath: "referralApiV5",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.referralService}/v5/referrals`,
    prepareHeaders: authorizationHeaders,
  }),
  endpoints: builder => ({
    createSelfReferral: builder.mutation<CreatedReferralV5Response, CreateReferralV5Command>({
      query(data) {
        return {
          url: `/self`,
          method: "POST",
          body: { ...data },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useCreateSelfReferralMutation } = referralApiV5;
